import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {NON_HERO_BACKGROUND} from "../../constants/styles";

export default function DashboardCarousel({ children }) {

  const [index, setIndex] = useState(0);

  const itemsPerPage = 2;

  const childArray = React.Children.toArray(children);
  const totalPages = Math.ceil(childArray.length / itemsPerPage);

  const next = () => {
    if (index < totalPages - 1) {
      setIndex(index + 1);
    }
  };

  const prev = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  return (
    <div style={container}>

      {/* LEFT ARROW */}
      {index > 0 && (
        <div style={{ ...arrowBase, left: "-12px" }} onClick={prev}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
      )}

      {/* VIEWPORT */}
      <div style={viewport}>

        {/* SLIDER */}
        <div
          style={{
            ...slider,
            transform: `translateX(-${index * 100}%)`
          }}
        >
          {childArray.map((child, i) => (
            <div key={i} style={item}>
              {child}
            </div>
          ))}
        </div>

      </div>

      {/* RIGHT ARROW */}
      {index < totalPages - 1 && (
        <div style={{ ...arrowBase, right: "-12px" }} onClick={next}>
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      )}

    </div>
  );
}

/* ================= STYLES ================= */

const container = {
  display: "flex",
  alignItems: "stretch",
  position: "relative",
  width: "100%",
  height:'100%'
};

const viewport = {
  overflow: "hidden",
  width: "100%",
  height:'100%',
  background:'transparent'
};

const slider = {
  display: "flex",
  width: "100%",
  transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
  height:'100%'
};

const item = {
  flex: "0 0 50%",   // 🔥 2 items per page
  paddingRight: "20px",
  boxSizing: "border-box",
  display: "flex",
  height: "100%"   
};

const arrowBase = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  background: "rgba(0,0,0,0.65)",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  zIndex: 10,
  fontSize: "14px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
  transition: "all 0.2s ease"
};